import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import store from '../../store';
import { useGetRecords } from 'root/admin/components/hooks';
import { Title, CreateNew } from 'root/admin/components';
import { ModelTable } from '../../components';
import { Row, Loader, Table, Column, RecordSelect, Field, RelationSelect } from '@smartplatform/ui';

const EditRecipients = ({ match, rootPath, tabName, history }) => {
	const { id } = match.params;
	const [options, setOptions] = useState();

	useEffect(() => {
		!options && setOptions({ where: { awardId: id }, order: 'createdAt DESC' });
	}, [options]);
	const years = useGetRecords({ model: 'AwardYear' });
	if (!years) {
		return <Loader />;
	}

	console.log('REcipients');

	const filters = () => {
		const onChange = e => {
			const yearId = e ? e.id : null;
			const where = yearId ? { awardId: id, yearId } : { awardId: id };
			setOptions({ ...options, where });
		};

		const yearId = options.where.yearId;

		return (
			<div>
				<h3>Фильтр по годам</h3>
				<RecordSelect
					model={store.model.AwardYear}
					property="name"
					value={years.filter(e => e.id === yearId)[0]}
					onChange={onChange}
				/>
			</div>
		);
	};

	return (
		<div>
			<Title name="Получатели награды" />
			<ModelTable
				filters={() => filters()}
				model="AwardRecipient"
				limit={20}
				options={options}
				tabName={tabName}
				path={`${rootPath}/${id}/${tabName}`}
				rootPath={`${rootPath}/${id}`}
			>
				<Column property="name" label="Получатель" />
				<Column relation="year" property="name" label="Год присуждения" />
				<Column property="createdAt" label="Дата добавления" />
			</ModelTable>
			{/* <CreateNew link={`${rootPath}/${id}/${tabName}/new`} name="Добавить получателя" />

			<Table records={records} rootPath={`${rootPath}/${id}`}>
				<Column property="name" label="Получатель" />
				<Column relation="year" property="name" label="Год присуждения" />
			</Table> */}
		</div>
	);
};

export default withRouter(EditRecipients);
